import 'semantic-ui-css/semantic.min.css';
import { useStore } from '../../app/stores/store';
import { operatorPerformanceType } from '../../app/models/Restoration';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import DynamicTableCSVReport from '../DynamicTable/DynamicTableCSVReport';
import { useEffect, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Header, Select, Table, Form, Button, Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';

const OperatorPerformace = () => {
  const { RestorationStore, PivotStore } = useStore();
  const [reportTypeValue, setReportTypeValue] = useState<string>('Report Type');
  const [tableEnable, SetTableEnable] = useState<boolean>(false);
  const [tableLoading,setTableLoading]=useState<boolean>(true);
  const [assingTitleCode, setAssignTitleCode] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [loadData, setLoadData] = useState<operatorPerformanceType[]>([]);
  const [reportType, setReportType] = useState<string>('');
  const reportTypeOptions = [
    { key: 1, text: 'Title Wise', value: 'Title Wise' },
    { key: 2, text: 'Date Wise', value: 'Date Wise' },
  ];
  let reportName = '';
  const currentDate = new Date();
  const [startDate, setStartDate] = useState(() => {
    return moment(currentDate).format('MM-DD-YYYY');
  });
  const [endDate, setendDate] = useState(() => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${month}-${day}-${year}`;
  });

  useEffect(() => {
    RestorationStore.getTitleCode();
    // eslint-disable-next-line
  }, []);

  const reportTypeAssign = async (event: any, data: any) => {
    const { value } = data;
    let reportType = reportTypeOptions.find((option) => option.value === value);
    if (reportType) {
      setReportTypeValue(reportType.value);
      if (reportType.value === 'Title Wise') {
        setReportType('Title Wise');
      } else if (reportType.value === 'Date Wise') {
        setReportType('Date Wise');
        setLoadData([]);
      } else {
        setReportType('');
        SetTableEnable(false);
        setLoadData([]);
      }
    } else {
      setReportTypeValue('Report Type');
      SetTableEnable(false);
      setLoadData([]);
      setReportType('');
    }
  };
  const titleBasedDataLoad = async (titlename: string) => {
    try {
      if (!titlename) {
        setLoadData([]);
        setTableLoading(false);
        return;
      }
      setTableLoading(true);
      await RestorationStore.performanceReportbyTitle(titlename);
      setLoadData(RestorationStore.operatorPerformanceData);
      //   setLoadData(RestorationStore.responseForDefectData);
      setTableLoading(false);
      SetTableEnable(true);
      reportName = 'Defect_Report' + titlename;
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
      setTableLoading(false);
      SetTableEnable(false);
    }
  };

  const dateBasedDataLoad = async () => {
    try {
      setTableLoading(true);
      await RestorationStore.performanceReportbyDateforDate(startDate, endDate);
      setLoadData(RestorationStore.operatorPerformanceData);
      setTableLoading(false);
      SetTableEnable(true);
      reportName = 'Defect_Report_From_' + startDate + '_upto_' + endDate;
      
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
      SetTableEnable(false);
      setTableLoading(false);
    }
  };

  const setDate = (data: any, type: string) => {
    try {
      if (type === 'start') {
        setStartDate(moment(data).format('MM-DD-YYYY'));
      } else {
        if (type === 'end') setendDate(moment(data).format('MM-DD-YYYY'));
      }
    } catch (error) {
      toast.error('Error fetching Date');
    }
  };
  useEffect(() => {
    const loadTitleCode = RestorationStore.titleCodeData.map(
      (titleCodeList: string) => {
        return {
          key: titleCodeList,
          text: titleCodeList,
          value: titleCodeList,
        };
      },
    );
    setAssignTitleCode(loadTitleCode);
    // eslint-disable-next-line
  }, [reportTypeValue]);
  return (
    <>
      <div className="title-wise-table">
        <Header> Operator Performance Report</Header>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h4
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingRight: '20px',
                paddingTop: '10px',
              }}
            >
              Report Type
            </h4>
            <Select
              placeholder="Report Type"
              filter
              selection
              search
              clearable
              options={reportTypeOptions}
              onChange={reportTypeAssign}
            />
            {reportType === 'Title Wise' ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h4
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingRight: '20px',
                    paddingTop: '10px',
                    paddingLeft: '20px',
                  }}
                >
                  Title Code{' '}
                </h4>
                <Select
                  style={{ display: 'flex', alignItems: 'center' }}
                  placeholder="Select Title code"
                  filter
                  Selection
                  search
                  clearable
                  options={assingTitleCode}
                  onChange={(_event, data) =>
                    titleBasedDataLoad(data.value as string)
                  }
                />
              </div>
            ) : reportType === 'Date Wise' ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <>
                    <h4
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: '20px',
                        paddingTop: '10px',
                      }}
                    >
                      From Date
                    </h4>
                    <DatePicker
                      placeholderText="From Date"
                      value={
                        startDate
                          ? PivotStore.dateFormat(
                              moment(startDate).format('MM-DD-YYYY'),
                            )
                          : ''
                      }
                      className="date-picker-style"
                      showMonthDropdown
                      showYearDropdown
                      locale={'en'}
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={15}
                      maxDate={moment().toDate()}
                      scrollableYearDropdown
                      onChange={(date: any) => setDate(date, 'start')}
                      popperProps={{ strategy: 'fixed' }}
                    />
                  </>
                </div>
                <Form.Field required={true}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <>
                      <h4
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          paddingTop: '10px',
                          paddingLeft: '20px',
                        }}
                      >
                        To Date{' '}
                      </h4>
                      <DatePicker
                        placeholderText="To Date"
                        value={
                          endDate
                            ? PivotStore.dateFormat(
                                moment(endDate).format('MM-DD-YYYY'),
                              )
                            : ''
                        }
                        className="date-picker-style"
                        showMonthDropdown
                        showYearDropdown
                        locale={'en'}
                        dateFormatCalendar="MMMM"
                        yearDropdownItemNumber={15}
                        maxDate={moment().add(0, 'days').toDate()}
                        scrollableYearDropdown
                        onChange={(date: any) => setDate(date, 'end')}
                        popperProps={{ strategy: 'fixed' }}
                      />
                    </>
                  </div>
                </Form.Field>
                <Form.Field>
                  <Button
                    primary
                    onClick={dateBasedDataLoad}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingRight: '20px',
                      paddingBottom: '10px',
                    }}
                  >
                    View Report
                  </Button>
                </Form.Field>
              </>
            ) : null}
            {loadData.length !== 0 && (
              <div style={{ textAlign: 'right', marginLeft: '5px' }}>
                <DynamicTableCSVReport
                  tableData={loadData}
                  tableName={reportName}
                />
              </div>
            )}
          </div>
        </div>
        <div>
          <br />
          {tableLoading===true && reportType!=='' &&(
                      <div>
                     <div>
                        <br/>
                        <Loader active inline='centered' > Please wait, this will take a few minutes... </Loader>
                      </div> 
                    </div>
                    )}
          {tableEnable && tableLoading===false && (
            <>
              {' '}
              <div>
                <Table>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Title Code</Table.HeaderCell>
                      <Table.HeaderCell>PL Name</Table.HeaderCell>
                      <Table.HeaderCell>Employee ID</Table.HeaderCell>
                      <Table.HeaderCell>Employee Name</Table.HeaderCell>
                      <Table.HeaderCell>Resolution</Table.HeaderCell>
                      <Table.HeaderCell>Reel Name</Table.HeaderCell>
                      <Table.HeaderCell>Shot Name</Table.HeaderCell>
                      <Table.HeaderCell>Complexity Level</Table.HeaderCell>
                      <Table.HeaderCell>Work Type</Table.HeaderCell>
                      <Table.HeaderCell>Target Frame</Table.HeaderCell>
                      <Table.HeaderCell>Actual Frame</Table.HeaderCell>
                      <Table.HeaderCell>Actual Hours</Table.HeaderCell>
                      <Table.HeaderCell>Extra Hours</Table.HeaderCell>
                      <Table.HeaderCell>Actual Frame Per Hour</Table.HeaderCell>
                      <Table.HeaderCell>Total Reject Frame</Table.HeaderCell>
                      <Table.HeaderCell>Start Date</Table.HeaderCell>
                      <Table.HeaderCell>End Date</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {loadData.length === 0 && (
                      <Table.Row>
                        <Table.Cell colSpan={20} textAlign="center">
                          Data is currently unavailable
                        </Table.Cell>
                      </Table.Row>
                    )}
                    {loadData.length !== 0 &&
                      loadData.map((data, index) => (
                        <Table.Row key={index}>
                          <Table.Cell>{data.title_code}</Table.Cell>
                          <Table.Cell>{data.pl_Name}</Table.Cell>
                          <Table.Cell>{data.emp_Id}</Table.Cell>
                          <Table.Cell>{data.emp_Name}</Table.Cell>
                          <Table.Cell>{data.resolution}</Table.Cell>
                          <Table.Cell>{data.reel_Name}</Table.Cell>
                          <Table.Cell>{data.shot_Name}</Table.Cell>
                          <Table.Cell>{data.complexity_Level}</Table.Cell>
                          <Table.Cell>{data.work_Type}</Table.Cell>
                          <Table.Cell>{data.target_Frame}</Table.Cell>
                          <Table.Cell>{data.actual_Frame}</Table.Cell>
                          <Table.Cell>{data.actual_Hours}</Table.Cell>
                          <Table.Cell>{data.extra_Hours}</Table.Cell>
                          <Table.Cell>{data.actual_Framepermin}</Table.Cell>
                          <Table.Cell>{data.total_Reject_Frame}</Table.Cell>
                          <Table.Cell>{data.startdate}</Table.Cell>
                          <Table.Cell>{data.endDate}</Table.Cell>
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default observer(OperatorPerformace);
